import React, { Component } from 'react'
import { render } from 'react-dom'

import '../../App.js'

import { InlineMath, BlockMath } from 'react-katex';

import {
  Header,
} from 'semantic-ui-react'

import 'katex/dist/katex.min.css';

class Chapter103 extends Component {
  render() {
    return (
      <div className="base">

        <Header as='h1'>
        1-3. 負の二項分布 (Negative Binomical Distribution)
        </Header>

　この章では、最初に重要な結論が書かれています。

<div className="box2">
  <p>個人個人の購買行動はポアソン分布をしているが、消費者全体を見ると「負の二項分布」をしている</p>
</div>


　なぜ、消費者全体を見ると負の二項分布をしているかが書かれておらず、以後、負の二項分布を仮定して議論が進みます。しかし、先の章の話になってしまいますが、1-4.の「ポアソン分布」と「負の二項分布」のまとめのP254の下の方に、

<ol className="ol_01">
  <li className="li_01">個人レベルでポアソン分布している</li>
  <li className="li_01">長期平均値 $\mu $は消費者全体で見たときガンマ分布している</li>
</ol>

と書かれており、さらに、

<div className="box2">
  <p>この二つの前提が成り立つとき、消費者全体で見たときにある期間の実際の購入確率は負の二項分布すると覚えてください</p>
</div>

と書かれています。つまり、消費者全体で見たときに負の二項分布をすると言うのは、1. と2. の結果でしかないのです。 <br/>

　その結果として、消費者全体によってあるカテゴリー、もしくは、あるブランドが選ばれる確率は

<BlockMath>{`
P\\left(r \\right) = \\frac{\\left(1 + \\frac{M}{K} \\right)^{-K} \\cdot \\Gamma\\left(K + r \\right)}{\\Gamma\\left(r + 1 \\right)\\cdot \\Gamma\\left(K \\right)} \\cdot \\left(\\frac{M}{M+K} \\right)^r
`}</BlockMath>

と計算できると述べています。その後に、その負の二項分布が、「成功が成功を呼ぶ分布」としてのガンマ分布を仮定することによって$\left(1 \right)$が導かれる事が証明されていますが、この理解は後で良いかと思います。繰り返しますが、重要なのは、 <br/>

<div className="box2">
  <p>ポアソン分布とガンマ分布を仮定することによって、負の二項分布が導かれる</p>
</div>


という事です。<br/> 

　※実際に個人レベルのポアソン分布と消費者全体でのガンマ分布を仮定することによって負の二項分布が導かれることは1.6で証明します。

      </div>
    )   
  }
}

export default Chapter103;
